module.exports = __webpack_public_path__ + "static/media/home.c9f0953c.svg";